import { ReactElement, useState } from 'react';
import { useMediaQuery } from 'src/hooks/useMediaQuery';
import { TABLET_UP } from 'src/assets/theme/breakpoints';
import { PrimaryButton, Typography } from '@weareopenr/component-library';
import styles from './EmptyState.module.scss';
import VenuesModal from '../VenuesModal';

interface IEmptyStateProps {
  type?: string;
  emptySectionText?: string;
  buttonText?: string;
  Icon?: (props: Record<string, unknown>) => ReactElement;
  onClick?: () => void;
}

const EmptyState = ({ emptySectionText, onClick, buttonText, type, Icon }: IEmptyStateProps): ReactElement => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const isMdUp = useMediaQuery(TABLET_UP);

  const handleModalToggle = (): void => {
    setIsModalVisible((prev) => !prev);
  };

  return (
    <div className={styles['empty-state']}>
      <div className={styles['content']}>
        {Icon && <Icon className={styles['icon']} width={32} />}
        <Typography size={isMdUp ? 'large' : 'medium'}>{emptySectionText}</Typography>
        <div className={styles['cta-container']}>
          {buttonText && (
            <PrimaryButton data-testid={`${type}-cta`} aria-label={buttonText} onClick={onClick}>
              <Typography size={isMdUp ? 'medium' : 'small'} weight="semi-bold" colour="secondary">
                {buttonText}
              </Typography>
            </PrimaryButton>
          )}
          {type === 'venues' && <VenuesModal closeModal={handleModalToggle} open={isModalVisible} />}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
